import ApiClient from '@lib/apiClient';

import { BASE_URL } from '@/constants/constant';

import { printApiError } from '@/utils/Util';

export const onApproveRequest = async (ids) => {
	try {
		const { data } = await ApiClient.POST('quantityWiseCostingAction', {}, `approve?ids=${ids}`);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const onRejectRequest = async (ids) => {
	try {
		const { data } = await ApiClient.POST('quantityWiseCostingAction', {}, `reject?ids=${ids}`);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const onUploadInitialCostingDocuments = async (id, documents) => {
	try {
		const { data } = await ApiClient.POST(
			`${BASE_URL}/initial-costing/${id}/document`,
			documents,
			'',
			true
		);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const setFactoryCosting = async (params) => {
	try {
		const { data } = await ApiClient.POST(
			`${BASE_URL}/initial-costing/factory-costing`,
			'',
			params,
			true
		);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const removeInitialCostingDocument = async (costingId, documentId) => {
	try {
		const { data } = await ApiClient.DELETE(
			`${BASE_URL}/initial-costing/${costingId}/document/${documentId}`,
			'',
			'',
			true
		);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const findAllSupplier = async (params) => {
	try {
		const { data } = await ApiClient.GET('searchSupplier', params);
		return data;
	} catch (error) {
		printApiError(error);
	}
};
